"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = require("../../../utils/epsilon-ajax-request");
var button_group_1 = require("../button-group");
var range_slider_1 = require("../range-slider");
var text_editor_1 = require("../text-editor");
var color_picker_1 = require("../color-picker");
var customizer_navigation_1 = require("../customizer-navigation");
var EpsilonRepeaterAddons = /** @class */ (function () {
    /**
     *
     * @param {EpsilonFieldRepeater | EpsilonSectionRepeater} control
     * @param {EpsilonRepeaterSectionRow | EpsilonRepeaterRow | any} row
     */
    function EpsilonRepeaterAddons(control, row) {
        this.control = control;
        this.row = row;
        this.proxy = this.control.control.params;
        if (this.row.hasOwnProperty('type')) {
            this.proxy = this.proxy.sections[this.row.type];
        }
    }
    /**
     * Init all plugins
     */
    EpsilonRepeaterAddons.prototype.initPlugins = function () {
        this.initRangeSliders();
        this.initImageUploads();
        this.initIconPicker();
        this.initTextEditor();
        this.initColorPickers();
        this.initButtonGroup();
        if (this.row.hasOwnProperty('type')) {
            this.initCustomizerNavigation();
            this.initSelectize();
        }
    };
    /**
     * Initiate button group
     */
    EpsilonRepeaterAddons.prototype.initButtonGroup = function () {
        var self = this;
        var settings = {
            container: self.row.container,
            repeater: true,
        };
        new button_group_1.EpsilonButtonGroup(settings);
    };
    /**
     * Selectize inputs
     */
    EpsilonRepeaterAddons.prototype.initSelectize = function () {
        this.row.container.find('.epsilon-selectize').selectize({
            plugins: ['remove_button'],
        });
    };
    /**
     * Init navigation between sections
     */
    EpsilonRepeaterAddons.prototype.initCustomizerNavigation = function () {
        var self = this;
        var init = false, settings;
        for (var k in self.proxy.fields) {
            if ('epsilon-customizer-navigation' === self.proxy.fields[k].type) {
                settings = self.row;
                new customizer_navigation_1.EpsilonCustomizerNavigation(settings);
            }
        }
    };
    /**
     * Init color pickers
     */
    EpsilonRepeaterAddons.prototype.initColorPickers = function () {
        var self = this;
        var init = false, settings;
        settings = self.row;
        new color_picker_1.EpsilonColorPicker(settings);
    };
    /**
     * Handle image uploads
     */
    EpsilonRepeaterAddons.prototype.initImageUploads = function () {
        var self = this;
        var temp;
        /**
         * Image controls - Upload
         */
        self.row.container.on('click keypress', '.epsilon-controller-image-container .image-upload-button', function (e) {
            e.preventDefault();
            if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                return;
            }
            temp = jQuery(this).parents('.epsilon-controller-image-container');
            self._imageUpload(temp);
        });
        /**
         * Image Controls - Removal
         */
        self.row.container.on('click keypress', '.epsilon-controller-image-container .image-upload-remove-button', function (e) {
            e.preventDefault();
            if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                return;
            }
            temp = jQuery(this).parents('.epsilon-controller-image-container');
            self._imageRemoval(temp);
        });
    };
    /**
     * Image Upload
     * @private
     */
    EpsilonRepeaterAddons.prototype._imageUpload = function (container) {
        var self = this;
        var setting = {}, temp, size, val, input, image = wp.media({
            multiple: false,
        }).open();
        /**
         * On selection, save the data in a JSON
         */
        image.on('select', function () {
            input = container.find('input');
            temp = image.state().get('selection').first();
            size = input.attr('data-size');
            if ('undefined' === typeof (temp.toJSON().sizes[size])) {
                size = 'full';
            }
            setting.id = temp.id;
            setting.url = temp.toJSON().sizes[size].url;
            val = ('url' === input.attr('data-save-mode')) ? setting.url : setting.id;
            input.val(val);
            self._setImage(container, setting.url);
            container.find('.actions .image-upload-remove-button').show();
        });
    };
    /**
     * Removes image
     * @private
     */
    EpsilonRepeaterAddons.prototype._imageRemoval = function (container) {
        var self = this;
        var thumb = container.find('.epsilon-image');
        if (thumb.length) {
            thumb.find('img').fadeOut(200, function () {
                var html = EpsilonTranslations.selectFile + '<span class="recommended-size"></span>', Ajax, data = {
                    action: ['Epsilon_Helper', 'get_image_sizes'],
                    nonce: EpsilonWPUrls.ajax_nonce,
                    args: [],
                }, size = container.find('input').attr('data-size');
                thumb.removeClass('epsilon-image').addClass('placeholder').html(html);
                Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(data);
                Ajax.request();
                jQuery(Ajax).on('epsilon-received-success', function (e) {
                    if (!_.isUndefined(Ajax.result[size])) {
                        thumb.find('.recommended-size').text(Ajax.result[size].width + ' x ' + Ajax.result[size].height);
                    }
                });
            });
        }
        container.find('.actions .image-upload-remove-button').hide();
        container.find('input').attr('value', '').trigger('change');
    };
    /**
     * Sets the uploaded image
     * @private
     */
    EpsilonRepeaterAddons.prototype._setImage = function (container, url) {
        /**
         * If we already have an image, we need to return that div, else we grab the placeholder
         *
         * @type {*}
         */
        var thumb = container.find('.epsilon-image').length ? container.find('.epsilon-image') : container.find('.placeholder');
        /**
         * We "reload" the image container
         */
        if (thumb.length) {
            thumb.removeClass('epsilon-image placeholder').addClass('epsilon-image');
            thumb.html('');
            thumb.append('<img style="display:none" src="' + url + '" />');
            thumb.find('img').fadeIn(200);
        }
        container.find('input').trigger('change');
    };
    /**
     * Icon picker
     */
    EpsilonRepeaterAddons.prototype.initIconPicker = function () {
        var self = this;
        var init = false, temp;
        for (var k in self.proxy.fields) {
            if ('epsilon-icon-picker' === self.proxy.fields[k].type) {
                init = true;
                /***
                 * Toggle
                 */
                self.row.container.on('click keypress', '.epsilon-icon-picker-repeater-container .epsilon-icon-container', function (e) {
                    e.preventDefault();
                    if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                        return;
                    }
                    jQuery(this).toggleClass('opened-icon-picker');
                    temp = jQuery(this).parents('.epsilon-icon-picker-repeater-container');
                    self._iconPickerToggle(temp);
                });
                /**
                 * Selection
                 */
                self.row.container.on('click keypress', '.epsilon-icon-picker-repeater-container .epsilon-icons-container .epsilon-icons > i', function (e) {
                    e.preventDefault();
                    if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                        return;
                    }
                    temp = jQuery(this).parents('.epsilon-icon-picker-repeater-container');
                    self._iconPickerSelection(this, temp);
                });
                /**
                 * Filtering
                 */
                self.row.container.on('keyup change', '.epsilon-icon-picker-repeater-container .search-container input', _.debounce(function (e) {
                    e.preventDefault();
                    if (wp.customize.utils.isKeydownButNotEnterEvent(e)) {
                        return;
                    }
                    temp = jQuery(this).parents('.epsilon-icon-picker-repeater-container');
                    self._iconPickerFilter(this, temp);
                }, 1000));
            }
        }
    };
    /**
     * Toggle the icon picker dropdown
     * @private
     */
    EpsilonRepeaterAddons.prototype._iconPickerToggle = function (container) {
        container.find('.epsilon-icon-picker-container').toggleClass('opened');
    };
    /**
     * Icon pick
     * @private
     */
    EpsilonRepeaterAddons.prototype._iconPickerSelection = function (clicked, container) {
        var icon, label;
        container.find('.epsilon-icons > i.selected').removeClass('selected');
        icon = jQuery(clicked).addClass('selected').attr('data-icon');
        label = jQuery(clicked).attr('data-search');
        container.find('.epsilon-icon-name > i').removeClass().addClass(icon);
        container.find('.epsilon-icon-name > .icon-label').html(label);
        /**
         * Set value
         */
        container.find('.epsilon-icon-picker').attr('value', icon).trigger('change');
    };
    /**
     * Icon picker filtering
     * @private
     */
    EpsilonRepeaterAddons.prototype._iconPickerFilter = function (input, container) {
        var filter, temp, collection = jQuery(container).find('.epsilon-icons > i');
        filter = jQuery(input).val();
        if ('undefined' !== typeof filter) {
            filter = filter.toLowerCase();
        }
        jQuery.each(collection, function () {
            temp = jQuery(this).attr('data-search');
            if ('undefined' !== typeof temp) {
                temp = temp.toLowerCase();
            }
            jQuery(this)[temp.indexOf(filter) !== -1 ? 'show' : 'hide']();
        });
    };
    /**
     * WP Texteditor
     */
    EpsilonRepeaterAddons.prototype.initTextEditor = function () {
        var self = this;
        var textareas = jQuery(self.row.container).find('textarea');
        var _loop_1 = function (i) {
            setTimeout(function () {
                var settings = {
                    container: jQuery(textareas[i]).parent(),
                    params: {
                        id: jQuery(textareas[i]).attr('id')
                    }
                };
                new text_editor_1.EpsilonTextEditor(settings, true);
            }, 100 * i);
        };
        for (var i = 0; i < textareas.length; i++) {
            _loop_1(i);
        }
    };
    /**
     * initiate range sliders
     */
    EpsilonRepeaterAddons.prototype.initRangeSliders = function () {
        var self = this;
        var init = false, sliderSettings, val;
        for (var k in self.proxy.fields) {
            if ('epsilon-slider' === self.proxy.fields[k].type) {
                init = true;
                sliderSettings = {
                    container: self.row.container,
                    params: {
                        id: self.proxy.fields[k].id,
                        sliderControls: {
                            min: self.proxy.fields[k].choices.min,
                            max: self.proxy.fields[k].choices.max,
                            step: self.proxy.fields[k].choices.step
                        }
                    }
                };
                if (self.row.hasOwnProperty('type')) {
                    sliderSettings.params.value = parseFloat(self.proxy.fields[k].default);
                    if ('undefined' !== typeof self.control.control.params.value[self.row.index]) {
                        sliderSettings.params.value = parseFloat(self.control.control.params.value[self.row.index][k]);
                    }
                    new range_slider_1.EpsilonRangeSlider(sliderSettings);
                    return;
                }
                if ('undefined' !== typeof self.proxy.value[self.row.index]) {
                    sliderSettings.params.value = parseFloat(self.proxy.value[self.row.index][k]);
                }
                sliderSettings.container = jQuery(sliderSettings.container).find('.epsilon-slider:not(.initiated)').first().addClass('initiated');
                new range_slider_1.EpsilonRangeSlider(sliderSettings);
            }
        }
    };
    return EpsilonRepeaterAddons;
}());
exports.EpsilonRepeaterAddons = EpsilonRepeaterAddons;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/repeater/repeater-addons.ts
// module id = 7
// module chunks = 0